// export const DATA_POINT_TYPES = [
//   'General Notes',
//   'Soil Data',
//   'Issue Log',
//   'Crop Cycle',
// ] as const;
// export type DataPointType = (typeof DATA_POINT_TYPES)[number];
export enum EDataPointType {
  GENERAL_NOTES = 'General Notes',
  SOIL_DATA = 'Soil Data',
  ISSUE_LOG = 'Issue Log',
  GROWTH_OBSERVATION = 'Growth Observation',
  MANAGEMENT_LOG = 'Management Log',
  HARVEST_SUMMARY = 'Harvest Summary',
  POST_HARVEST_REVIEW = 'Post Harvest Review',
  CUSTOMER_SUPPORT = 'Customer Support',
}

export enum EGrowthObservationStage {
  PRE_PLANT = 'Pre-plant',
  PLANT = 'Plant',
  POST_PLANTING = 'Post planting',
  GERMINATION = 'Germination',
  VEGETATIVE_GROWTH = 'Vegetative growth',
  FRUIT_SET_BULKING = 'Fruit set / Bulking',
  PRE_HARVEST = 'Pre Harvest',
}
export const NOTE_TITLE_MAX = 160;
export const NOTE_BODY_MAX = 1000;
export const ACCEPTED_IMAGE_TYPES = [
  'image/jpeg',
  'image/png',
  'image/gif',
  'image/webp',
];
